module.exports = __webpack_public_path__ + "static/media/10. Lagrimas. Resina epóxica, 110 x 280 cm,2019 copy.ba766fc1.png";